<script>
	import { getContext } from 'svelte'
	import { getCookie, setCookie } from '../library/scripts/cookie.js'
	import { styles } from '../library/scripts/styles.js'
	import { fade } from 'svelte/transition'
	import { cookieConsent, cookieConsent1 } from '../library/scripts/Setup.svelte'

	const globals = getContext('globals')
	const fsS = globals.fsS
	const fsN = globals.fsN
	const colorMain = globals.adminColorMain
	const bgDark = globals.adminBgDark

	//see if the cookie consent is set
	let showConsent = true
	let consent = getCookie('cons')

	//cookie is set
	if (consent) showConsent = false

	const set_consent = () => {
		showConsent = false
		setCookie('cons', 't', 10)
	}
</script>

{#if showConsent}
	<div class="outer" out:fade={{ duration: 1500 }}>
		<div class="container" use:styles={{ fsS, bgDark, colorMain }}>
			<div class="consent">
				<div>{cookieConsent}</div>
				<div>{cookieConsent1}</div>
			</div>
			<button use:styles={{ colorMain, fsN }} on:click={set_consent}>ok</button>
		</div>
	</div>
{/if}

<style>
	.outer {
		position: fixed;
		top: 0px;
		left: 0px;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		width: 100vw;
		height: 100%;
		background: hsla(0, 0%, 0%, 0.8);
		z-index: 100;
	}

	.container {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		height: clamp(80px, 9.2vw, 140px);
		padding: 10px;
		font-size: var(--fsS);
		background: var(--bgDark);
		color: var(--colorMain);
	}

	button {
		display: flex;
		align-items: center;
		justify-content: center;
		outline: none;
		margin-right: 20px;
		padding: none;
		width: clamp(60px, 6.5vw, 100px);
		height: clamp(30px, 3.35vw, 50px);
		font-size: var(--fsN);
		color: var(--color);
		background-color: hsl(217, 35%, 45%);
		cursor: pointer;
	}

	button:hover {
		background-color: hsl(217, 35%, 55%);
	}

	.consent {
		display: flex;
		flex-direction: column;
	}
</style>
